import styled, { keyframes } from "styled-components";

interface LoadingT {
  hasDisabled?: any;
  right?: boolean;
  color?: string;
}

export const Loading = styled.div<any>`
  position: absolute;
  & * {
    padding: 0 !important;
  }
  padding: 0 !important;
  left: ${(props: LoadingT) => (props.right ? "auto" : 0)} !important;
  right: ${(props: LoadingT) => (props.right ? "10px" : 0)} !important;
  top: ${(props: LoadingT) => (props.right ? "auto" : 0)} !important;
  bottom: ${(props: LoadingT) => (props.right ? "auto" : 0)} !important;
  background-color: transparent;
  display: ${(props: LoadingT) =>
    props.hasDisabled ? "block" : "none"} !important;
  border: none !important;
  .lds-dual-ring {
    display: inline-block;
    width: 30px;
    height: 30px;
    border: none !important;
    &:after {
      content: " ";

      display: block;
      width: 24px;
      height: 24px;
      margin: 4px;
      border-radius: 50%;
      border: 2px solid ${({ theme }) => theme.white.main};
      border-color: #fff transparent #fff transparent;
      border: 2px solid
        ${(props: LoadingT) => (props.color ? props.color : "#fff")};
      border-color: ${(props: LoadingT) => (props.color ? props.color : "#fff")}
        transparent ${(props: LoadingT) => (props.color ? props.color : "#fff")}
        transparent;
      animation: ${() => loading} 1.2s ease-in-out infinite;
    }
  }
`;

const loading = keyframes`
   0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(720deg);
  }  
`;
